export default "assets/images/logo-1ac38273.png";